import { useWorkingPlatform } from '@repo/platform';
import { SignDefaultLayout, SignInContent } from '@repo/user-sign';
import { TopNavigation } from '@zenterprise-inc/ui';

import { useExitService } from '@/lib/hooks/use-exit-service';

const SignInPage = () => {
  const { workingPlatform } = useWorkingPlatform();
  const { exitService } = useExitService();
  return (
    <>
      {workingPlatform === 'kbank' && <TopNavigation.Basic rightTextButton={{ label: '나가기', onClick: exitService }} />}
      <SignDefaultLayout>
        <SignInContent />
      </SignDefaultLayout>
    </>
  );
};

export default SignInPage;
